<template>
  <div>
    <div class="large-padding-bottom-xl large-padding-top-xl small-padding-top-m small-padding-bottom-m header-sub-container">
      <div class="grid-x align-center-middle grid-margin-x grid-margin-y">
        <div class="cell small-12 medium-12 large-8 xlarge-8 header-1">
          <div class="grid-x registrants-wrapper">
            <div class="event-type-image">
              <picture>
                <source type="image/avif" :srcset="headerIconUrlAvif" />
                <source type="image/webp" :srcset="headerIconUrl" />
                <img :src="headerIconUrl" alt="" width="130" height="130" fetchpriority="high" decoding="async" />
              </picture>
            </div>
            <div class="registrants-contents small-margin-top-xs">
              <div class="eyebrow occasion-type">
                {{ checkOcassionTitle }}
              </div>
              <div
                v-if="Object.keys(headerBannerData).length > 0"
                class="large-text-left text-center medium-margin-bottom-xxs margin-bottom-xxs small-margin-bottom-xxs header-text-1"
                :class="{ h3: !checkMew, h4: checkMew }"
                data-fs-mask
              >
                {{ eventTitle }}
              </div>
              <div class="registry-event-details grid-x">
                <div
                  v-if="headerBannerData?.occasionDate"
                  class="xlarge-padding-right-xs medium-padding-right-xxs medium small-padding-right-xxs event"
                  data-fs-mask
                >
                  {{ registryFormatDate(headerBannerData?.occasionDate, true) }}
                </div>
                <div class="xlarge-padding-right-xs xlarge-padding-left-xs padding-left-xxs padding-right-xxs grid-x event">
                  <p class="medium">Registry ID: &nbsp;</p>
                  <p data-fs-mask>{{ headerBannerData?.registryId }}</p>
                </div>
                <div
                  v-if="salesFloorId && !booxiWidgetEnabledKS"
                  class="xlarge-padding-right-xs xlarge-padding-left-xs padding-left-xxs padding-right-xxs align-center grid-x event show-for-large"
                >
                  <a class="align-center-middle grid-x" :href="salesFloorLink" target="_blank" @click="contactConsultant">
                    <div class="medium-margin-right-xxs chat-icon-container">
                      <span class="chat large-margin-right-xxs"></span>
                    </div>
                    <p>
                      {{ isBabyRegistry ? babyRegistryConfig.manageRegistry.headerContactConsultant : manageRegistry.headerContactConsultant }}
                    </p>
                  </a>
                </div>
                <div
                  v-if="isRegistrant"
                  class="xlarge-padding-right-xs xlarge-padding-left-xs padding-left-xxs padding-right-xxs align-center grid-x event show-for-large"
                >
                  <a href="javascript:void(0)" class="align-center-middle grid-x" @click="openSettings">
                    <div class="medium-margin-right-xxs settings-icon-container">
                      <span class="settings large-margin-right-xxs"></span>
                    </div>
                    <p>Settings</p>
                  </a>
                </div>
                <div
                  v-if="isRegistrant"
                  class="xlarge-padding-left-xs small-padding-left-xxs medium-padding-left-xxs align-center grid-x event show-for-large"
                >
                  <a href="javascript:void(0)" class="grid-x align-center-middle" @click="openShareRegistrySlideout">
                    <div class="medium-margin-right-xxs utility-share-icon-container">
                      <span class="utility-share-ios large-margin-right-xxs"></span>
                    </div>
                    <p>Share</p>
                  </a>
                </div>
                <div v-if="!isRegistrant" class="small-padding-left-xxs medium-padding-left-xs align-center grid-x event show-for-large">
                  <button variant="link" class="grid-x align-center-middle" @click="print">
                    <span class="medium-margin-right-xxs utility-print-icon-container">
                      <span class="utility-print large-margin-right-xxs"></span>
                    </span>
                    <span class="print-text">Print</span>
                  </button>
                </div>
                <div class="cell align-center-middle registry-util-icons-mew hide-for-large">
                  <div
                    v-if="salesFloorId && !booxiWidgetEnabledKS"
                    class="medium-padding-left-xxs medium-padding-right-xxs small-padding-left-xs small-padding-right-xs align-center grid-x event"
                  >
                    <a class="align-center-middle grid-x" :href="salesFloorLink" target="_blank" @click="contactConsultant">
                      <div class="medium-margin-right-xxs chat-icon-container">
                        <span class="chat large-margin-right-xxs"> ''</span>
                      </div>
                    </a>
                  </div>
                  <div
                    v-if="isRegistrant"
                    class="medium-padding-left-xxs medium-padding-right-xxs small-padding-left-xs small-padding-right-xs align-center grid-x event"
                  >
                    <a href="javascript:void(0)" class="align-center-middle grid-x" @click="openSettings">
                      <div class="medium-margin-right-xxs settings-icon-container">
                        <span class="settings large-margin-right-xxs">'' </span>
                      </div>
                    </a>
                  </div>
                  <template v-if="isRegistrant">
                    <AtomicUiSlideout
                      id="share-registry"
                      :title="privacyPreferenceApiTimeout ? '' : manageRegistry.shareRegistryTitle"
                      position="right"
                      :is-disabled="privacyPreferenceApiTimeout ? true : privacyPreferenceLoader"
                      handle-top-layer="show"
                      @close-slideout="closeSlideout"
                    >
                      <ShareRegistry
                        v-if="enableShareRegistry"
                        :visibility-status="headerBanner.privacyPreference"
                        :registry-link-text="registryLink"
                        :registrant-name="registrantName"
                        :co-registrant-name="coRegistrantName"
                        :header-banner-data="headerBannerData"
                      />
                    </AtomicUiSlideout>
                  </template>
                  <div v-if="isRegistrant" class="medium-padding-left-xxs small-padding-left-xs align-center grid-x event">
                    <a href="javascript:void(0)" class="grid-x align-center-middle" @click="openShareRegistrySlideout">
                      <div class="medium-margin-right-xxs utility-share-icon-container">
                        <span class="utility-share-ios large-margin-right-xxs"> ''</span>
                      </div>
                    </a>
                  </div>
                  <div v-if="!isRegistrant" class="small-padding-left-xxs medium-padding-left-xs align-center grid-x event">
                    <AtomicUiButton variant="link" class="grid-x align-center-middle" @click="print">
                      <div class="medium-margin-right-xxs utility-print-icon-container">
                        <span class="utility-print large-margin-right-xxs"></span>
                      </div>
                    </AtomicUiButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cell small-12 medium-12 large-4 xlarge-4 digit-text medium-margin-top-xs small-margin-top-xxs header-2">
          <div class="meta-info grid-x">
            <div v-if="isRegistrant" class="text-center xlarge-padding-right-m large-padding-right-xxs medium-padding-right-m small-padding-right-m">
              <div class="h2 padding-bottom-xxs">
                {{ headerBannerData?.giftsAdded }}
              </div>
              <div class="macys-sans-regular-h3">
                {{ manageRegistry.giftsAdded }}
              </div>
            </div>
            <div v-if="isRegistrant" class="text-center xlarge-padding-right-m large-padding-right-xxs medium-padding-right-m small-padding-right-m">
              <div class="h2 padding-bottom-xxs">
                {{ headerBannerData?.giftsPurchased }}
              </div>
              <div class="macys-sans-regular-h3">
                {{ manageRegistry.giftsPurchased }}
              </div>
            </div>
            <div class="text-center">
              <div class="h2 padding-bottom-xxs">
                {{ headerBannerData?.daysAway }}
              </div>
              <div class="macys-sans-regular-h3">
                {{ manageRegistry.daysAwayText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { fireTag } from '@nuxt-common/util/app/utils/tagManager';
import { manageRegistry, babyRegistryConfig } from 'config';
import { registryFormatDate } from '~/utils/SearchRegistryUtil';
import { useHeaderBannerStore } from '~/stores/headerBanner';
import { useEnvPropsStore } from '~/stores/envProps';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ShareRegistry = defineAsyncComponent(() => import('@/components/ShareRegistry'));

const props = defineProps({
  headerBannerData: {
    type: Object,
    default: () => ({}),
    required: false,
  },
});

const envPropsStore = useEnvPropsStore();
const cdnUrl = envPropsStore.envProps?.cdnUrl || '';
const headerBannerStore = useHeaderBannerStore();
const slideoutStore = useSlideoutStore();
const baseStore = useBaseStore();
const route = useRoute();
const router = useRouter();
const headerBanner = computed(() => headerBannerStore.headerBanner);
const siteDomain = computed(() => envPropsStore.envProps.siteDomain);
const salesFloorId = computed(() => headerBanner.value?.salesFloorId);
const orgId = computed(() => (envPropsStore.envProps.entryPoint.toUpperCase() === 'MCOM' ? 12 : 13));
const salesFloorLink = computed(() => `https://store${orgId.value === 12 ? '-macys.com/en_US' : 's-bloomingdales.com'}/${salesFloorId.value}?chat=1`);
const booxiWidgetEnabledKS = computed(() => baseStore.isBooxiWidgetEnabled);

const registrant = computed(() => headerBanner.value?.registrants.find((obj) => obj.role.toUpperCase() === 'REGISTRANT'));
const coRegistrant = computed(() => headerBanner.value?.registrants.find((obj) => obj.role.toUpperCase() === 'PARTNER'));

const registrantName = computed(() => (registrant.value ? `${registrant.value.firstName} ${registrant.value.lastName}` : ''));
const coRegistrantName = computed(() => (coRegistrant.value ? `${coRegistrant.value.firstName} ${coRegistrant.value.lastName}` : ''));

const isBabyRegistry = computed(() => props.headerBannerData?.occasionType?.toUpperCase() === 'BABY');

const headerIconUrl = computed(() => {
  const iconName = isBabyRegistry.value ? manageRegistry.headerProfileIconBaby : manageRegistry.headerProfileIconWedding;
  return `${cdnUrl}/img/${iconName}`;
});

const toAvif = (url) => (/\.webp(\?|$)/i.test(url || '') ? url.replace(/\.webp(\?|$)/i, '.avif$1') : url);
const headerIconUrlAvif = computed(() => toAvif(headerIconUrl.value));

useHead(() => {
  return {
    link: [
      {
        rel: 'preload',
        as: 'image',
        href: headerIconUrlAvif.value,
        type: 'image/avif',
        fetchpriority: 'high',
      },
      {
        rel: 'preload',
        as: 'image',
        href: headerIconUrl.value,
        type: 'image/webp',
      },
    ],
  };
});

const formatName = (name) => (name ? name.trim().split(/\s+/).join('_') : '');

const registryLink = computed(() => {
  let path = `${siteDomain.value}/registry/${formatName(registrant.value.firstName)}-${formatName(registrant.value.lastName)}`;
  if (coRegistrant.value?.firstName && coRegistrant.value?.lastName) {
    path += `-${formatName(coRegistrant.value.firstName)}-${formatName(coRegistrant.value.lastName)}`;
  }
  path += `/${headerBanner.value.registryId}`;
  return path;
});

const privacyPreferenceLoader = computed(() => headerBanner.value?.privacyPreferenceLoader);
const privacyPreferenceApiTimeout = computed(() => headerBannerStore.headerBanner?.privacyPreferenceApiTimeout);
const enableShareRegistry = ref(false);
const openShareRegistrySlideout = () => {
  enableShareRegistry.value = true;
  slideoutStore.toggle('share-registry');
  fireTag('link', {
    event_name: 'registry share click',
    custom_link_name: 'registry share click',
  });
};
const closeSlideout = () => {
  enableShareRegistry.value = false;
  headerBannerStore.setShareRegistryVisibilityStatusApiError(null);
};
const checkMew = computed(() => envPropsStore.envProps.isMew);
const isRegistrant = computed(() => {
  if (route.path.includes('/registry/manage')) {
    return true;
  }
  return false;
});

const eventTitle = computed(() => {
  if (isRegistrant.value) {
    return coRegistrantName.value ? `${registrantName.value} & ${coRegistrantName.value}` : `${registrantName.value}`;
  }
  return props.headerBannerData?.eventTitle;
});

const checkOcassionTitle = computed(() => {
  const ocassionData = props.headerBannerData;
  if (ocassionData.occasionType) {
    return `${ocassionData.occasionType} Registry`;
  }
  return 'Registry Event';
});

const openSettings = () => {
  fireTag('link', {
    event_name: 'registry settings click',
    custom_link_name: 'registry settings click',
  });
  router.push('/registry/settings');
};

const contactConsultant = () => {
  fireTag('link', {
    event_name: 'registry request appointment click',
    custom_link_name: 'registry request appointment click',
  });
};

const print = () => {
  window.print();
  fireTag('link', {
    event_name: 'registry details: print click',
    custom_link_name: 'registry details: print click',
  });
};
</script>
<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_settings.scss';
@import '~@core/csg/src/scss/encodedIcons/mcom/_utility-share-ios.scss';
@import '~@core/csg/src/scss/encodedIcons/mcom/_utility-print.scss';
@import '~@core/csg/src/scss/encodedIcons/mcom/chat.scss';
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';

.occasion-type,
.digit-text .macys-sans-regular-h3 {
  color: $gray-1-color;
}
.print-text {
  border-bottom: $black-border;
}
.utility-print,
.print-text,
.settings-btn {
  cursor: pointer;
}
@include breakpoint(xlarge down) {
  .registry-info {
    padding-left: rem-calc(22);
  }
}
@include breakpoint(medium down) {
  .registry-info {
    padding-left: rem-calc(0);
  }
}
.registry-event-details {
  @include breakpoint(medium up) {
    display: flex;
    flex-flow: row wrap;
  }

  @include breakpoint(medium down) {
    justify-content: center;
    .registry-event {
      justify-content: center;
    }
  }
  @include breakpoint(small down) {
    .registry-event {
      &:nth-child(1) {
        margin-bottom: rem-calc(12);
      }
    }
  }
  div.event {
    position: relative;
    &:before {
      content: '';
      height: rem-calc(13);
      width: rem-calc(1);
      position: absolute;
      left: 0;
      top: rem-calc(4);
      background-color: $gray-4-color;
    }
    &:nth-child(1)::before {
      background-color: transparent;
    }
    @include breakpoint(small down) {
      &:nth-child(1)::before {
        background-color: transparent;
      }
    }
    @include breakpoint(large only) {
      &:nth-child(1)::before {
        background-color: transparent;
      }
    }
  }
}
.settings,
.utility-share-ios,
.utility-print {
  background-size: rem-calc(16) rem-calc(16);
}
.chat,
.chat-share-ios,
.chat {
  background-size: rem-calc(16) rem-calc(16);
}
.event-type-image {
  width: rem-calc(130);
  height: rem-calc(130);
  border-radius: 50%;
  overflow: hidden;
  margin-right: rem-calc(30);
  background-color: #f8f8f8;
  :deep(img) {
    width: rem-calc(130);
    height: rem-calc(130);
    display: block;
    margin: 0 auto;
    object-fit: contain;
  }
  @include breakpoint(medium down) {
    width: rem-calc(60);
    height: rem-calc(60);
    margin: 0 auto;
    :deep(img) {
      width: rem-calc(61);
      height: rem-calc(61);
    }
  }
}

.registrants-wrapper {
  .registrants-contents {
    display: flex;
    justify-content: center;
    flex-flow: column;
    @include breakpoint(large down) {
      width: 74%;
    }
    @include breakpoint(medium down) {
      width: 100%;
    }
  }
  @include breakpoint(medium down) {
    flex-flow: column;
    .registrants-contents {
      align-items: center;
    }
  }
}

.registry-util-icons-mew {
  display: flex;
  margin-top: rem-calc(13);
}

@include breakpoint(small down) {
  .settings,
  .utility-share-ios,
  .utility-print {
    width: rem-calc(16);
    height: rem-calc(16);
  }
}
.chat-icon-container,
.settings-icon-container,
.utility-share-icon-container {
  height: rem-calc(15);
  width: rem-calc(15);
  @include breakpoint(medium down) {
    margin-left: rem-calc(8);
  }
  @include breakpoint(small down) {
    margin-left: 0;
  }
}

.utility-print-icon-container {
  height: rem-calc(13);
  width: rem-calc(16);
}
.meta-info {
  @include breakpoint(medium down) {
    justify-content: center;
  }
  @include breakpoint(large up) {
    justify-content: flex-end;
  }
}

@media print {
  .header-1 {
    width: calc(80% - 1.5rem) !important;
  }
  .header-2 {
    width: calc(20% - 1.5rem) !important;
  }
  .header-text-1,
  .occasion-type {
    text-align: left !important;
  }
  .registrants-contents {
    align-items: start !important;
  }
  .registry-event-details {
    justify-content: left !important;
  }
  .event-type-image {
    width: rem-calc(130);
    height: rem-calc(130);
    border-radius: 50%;
    overflow: hidden;
    margin-left: 0;
    margin-right: rem-calc(30);
    :deep(img) {
      width: rem-calc(130);
      height: rem-calc(130);
      display: block;
      margin: 0 auto;
    }
  }
  .registrants-wrapper {
    flex-flow: row wrap !important;
  }
  .registrants-contents {
    display: flex !important;
    justify-content: center !important;
    flex-flow: column !important;
    width: 70% !important;
  }
  .header-sub-container {
    margin-bottom: rem-calc(24) !important;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
@import '~@core/csg/src/scss/encodedIcons/bcom/_chat.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_settings.scss';
.settings {
  width: rem-calc(16);
  height: rem-calc(16);
  background-size: rem-calc(16) rem-calc(16);
}
.chat {
  width: rem-calc(22);
  height: rem-calc(22);
  background-size: rem-calc(22) rem-calc(22);
}
.chat-icon-container {
  height: rem-calc(18);
}
</style>
